import React, { useState, useEffect } from "react";
import {
  Container,
  Body,
  ButtonContainer,
  NavContainer,
  Button,
  Input,
} from "./styles";
import EmailList from "../../EmailList";
import { GrFormClose } from "react-icons/gr";

const ModelListarAluno = ({ closeModal, emails, setEmails }) => {
  const [search, setSearch] = useState("");
  const [buttonMode, setButtonMode] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);

  const handleDeleteEmails = () => {
    const newEmails = emails.filter(
      (_, index) => !selectedEmails.includes(index)
    );
    setEmails(newEmails);
    setSelectedEmails([]);
    setButtonMode(false);
  };

  const handleClick = () => {
    if (buttonMode) {
      handleDeleteEmails();
      return;
    }

    setButtonMode(true);
  };

  return (
    <Container>
      <div className="header">
        <h3>Ver alunos</h3>
        <button onClick={closeModal}>
          <GrFormClose size={22} />
        </button>
      </div>

      <Body>
        <NavContainer>
          <Input
            type="text"
            placeholder="Pesquisar aluno"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

          <Button
            active={buttonMode}
            submitMode={buttonMode && selectedEmails.length > 0}
            onClick={() => handleClick()}
          >
            Excluir convites
          </Button>
        </NavContainer>

        <EmailList
          emails={emails}
          setEmails={setEmails}
          selectedEmails={selectedEmails}
          setSelectedEmails={setSelectedEmails}
          deleteMode={buttonMode}
          search={search}
        />

        <ButtonContainer>
          <button onClick={closeModal}>Concluir</button>
        </ButtonContainer>
      </Body>
    </Container>
  );
};

export default ModelListarAluno;
